import { render, staticRenderFns } from "./RedeemPromotion.vue?vue&type=template&id=5e48ecbe&scoped=true&"
import script from "./RedeemPromotion.vue?vue&type=script&lang=js&"
export * from "./RedeemPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48ecbe",
  null
  
)

export default component.exports